import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {ROUTES_PATHS} from "../const/routes";
import {SharedToolsService} from "../services/shared-tools.service";
import {denyAccessToMyInformation} from "../const/utils";

@Injectable({
	providedIn: 'root'
})
export class RedirectMonCompteGuard implements CanActivate {

	constructor(private router: Router, private sharedToolsService: SharedToolsService) {}

	canActivate(): boolean {
		const refKey = this.sharedToolsService.returnObjectSwitchRefId();

		if (denyAccessToMyInformation.includes(refKey)) {
			const tokenEnCours = JSON.parse(localStorage.getItem("token")!);
			const userId = tokenEnCours?.userId;

			if (userId) {
				localStorage.setItem("user_id", JSON.stringify(userId));
			}

			this.router.navigate([ROUTES_PATHS.ESTIMATIONS]);
			return false;
		}

		return true;
	}
}
